'use client';

const selectAnnouncementOptions = {
  id: "chalk-select"
};
const getLabelId = (id) => `${selectAnnouncementOptions.id}-label-id-${id}`;
export {
  getLabelId,
  selectAnnouncementOptions
};
